import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../../app/stores/store';
import DynamicTableComponent from '../../../DynamicTable/DynamicTableComponent';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import ApproveModalOutward from '../../../../app/common/modals/ApproveModalOutward';

interface Props {
  name: string;
}

function Outwardstable({ name }: Props) {
  const {
    activityStore: {
      tagOrderFetchTableDetails,
      outwardFetchTableDetails,
      outward,
      tagOrderFetchSortTableDetails,
      outwardFetchSortTableDetails,
    },
    dashboardStore: { dashboard },
    commonStore,
    userStore: { user },
  } = useStore();

  const [pageNumber, setPageNumber] = useState<number>(0);
  const [localName, setLocalName] = useState<string>('');
  const [roleIdfilterTwo, setRoleIdfilterTwo] = useState('');
  const [actionType, setActionType] = useState<string>('');

  useEffect(() => {
    setLocalName(name?.replaceAll(' ', ''));
    if (!!name?.length) {
      if (name === 'TagOrder') {
        if (
          user?.customerName !== 'NFAI' ||
          window.innerWidth > 1025 ||
          window.innerWidth < 1020
        ) {
          tagOrderFetchTableDetails('', 1, 'TagOrder');
        }
      } else {
        outwardFetchTableDetails('', 1, name.replaceAll(' ', ''));
      }
    }
    setPageNumber(1);
    // eslint-disable-next-line
  }, [name]);

  useEffect(() => {
    switch (localName) {
      case 'TagOrder':
        setRoleIdfilterTwo('OUDYT0');
        break;
      case 'Unvault':
        setRoleIdfilterTwo('OUDYT1');
        break;
      case 'VerifyOutward':
        setRoleIdfilterTwo('OUDYT2');
        break;
      case 'ApproveOutward':
        setRoleIdfilterTwo('OUDYT3');
        break;
      case 'Authorized Personnal':
        setRoleIdfilterTwo('OUDYT4');
        break;
      case 'Move':
        setRoleIdfilterTwo('OUDYT5');
        break;
      case 'Package':
        setRoleIdfilterTwo('OUDYT6');
        break;
      case 'Billing':
        setRoleIdfilterTwo('OUDYT7');
        break;
      default:
      // setRoleIdfilterTwo('OUDYT1');
    }
  }, [localName]);

  const caseHandler = () => {
    let tableDetails: any[] = [];
    switch (localName) {
      case 'TagOrder':
        tableDetails = outward.tagOrder.data;
        break;
      case 'Unvault':
        tableDetails = outward.unvault.data;
        break;
      case 'VerifyOutward':
        tableDetails = outward.verifyOutward.data;
        break;
      case 'ApproveOutward':
        tableDetails = outward.approveOutward.data;
        break;
      case 'Move':
        tableDetails = outward.move.data;
        break;
      case 'Package':
        tableDetails = outward.package.data;
        break;
      case 'AssignPickerOutward':
        tableDetails = outward.assignPickerOutward.data;
        break;
      case 'Billing':
        tableDetails = outward.billing.data;
        break;
      default:
        tableDetails = [];
    }
    return tableDetails;
  };

  const paginateFunction = (e: number) => {
    let searchValues = dashboard.searchfilterparams;
    if (
      !_.isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboard.orderData === '' &&
      dashboard.orderName === ''
    ) {
      if (name === 'TagOrder') {
        tagOrderFetchTableDetails(searchValues, e, localName);
      } else {
        outwardFetchTableDetails(searchValues, e, localName);
      }
    } else if (dashboard.orderData !== '' && dashboard.orderName !== '') {
      if (name === 'TagOrder') {
        tagOrderFetchSortTableDetails(
          dashboard.orderData,
          localName,
          dashboard.orderName || '',
          e || 1,
          (outward as any)[`${_.camelCase(localName)}`].count || 0,
        );
      } else {
        outwardFetchSortTableDetails(
          dashboard.orderData,
          localName,
          dashboard.orderName || '',
          e || 1,
          (outward as any)[`${_.camelCase(localName)}`].count || 0,
        );
      }
    } else {
      if (name === 'TagOrder') {
        tagOrderFetchTableDetails(searchValues, e, localName);
      } else {
        outwardFetchTableDetails(searchValues, e, localName);
      }
    }
    setPageNumber(e);
  };

  useEffect(() => {
    const L2 = dashboard.L2CardValueOrders;
    const L3 = dashboard.valueForL3Orders;
    const tempAction =
      L2 === 'Outward' && L3 === 'Unvault'
        ? 'Unvault Complete'
        : L2 === 'Outward' && L3 === 'Move'
          ? 'Move'
          : L2 === 'Outward' && L3 === 'ApproveOutward'
            ? 'Approve|Deny'
            : L2 === 'Outward' && L3 === 'Package'
              ? 'Pack'
              : L2 === 'Outward' && L3 === 'VerifyOutward'
                ? 'Verify|Deny'
                : '';
    setActionType(tempAction);
  }, [dashboard.L2CardValueOrders, dashboard.valueForL3Orders]);

  return (
    <>
      {/* <div className="table-dash" style={{ overflow: "auto", height: "49vh" }}> */}
      {dashboard.DenialModal ? (
        <ApproveModalOutward />
      ) : dashboard.reportsConfiguration ? (
        // <ReportsModal />
        <></>
      ) : null}
      {commonStore.filterModeTwo.includes(roleIdfilterTwo) ? (
        <></>
      ) : (
        !!localName?.length && (
          <DynamicTableComponent
            key={uuid()}
            data={caseHandler()}
            name={localName}
            actiontype={actionType}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            setPageNumber={setPageNumber}
            searchFuncData={() => {}}
            isdisabled={commonStore.filterModeZero.includes(roleIdfilterTwo)}
          />
        )
      )}
    </>
  );
}

export default observer(Outwardstable);
